
export default {
  head() {
    return {
      title: 'Store Policies • Pen The Journey',
      link: [
        {
          rel: 'canonical',
          href: 'https://penthejourney.com' + this.$route.path,
        },
      ],
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Our store policies and regulations',
        },
        /*         {
          hid: 'keywords',
          name: 'keywords',
          content: `${this.product.keywords}`,
        }, */
        //Facebook Open Graph Tags
        {
          hid: 'og:url',
          property: 'og:url',
          content: 'https://penthejourney.com/policies/',
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: 'Policies ∙ Pen The Journey',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: "Our store's rules and guidelines",
        },
        {
          hid: 'og:site_name',
          property: 'og:site_name',
          content: 'Pen The Journey',
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: 'https://penthejourney.com/ptjlogotransparent.png',
        },
        {
          hid: 'og:image:type',
          property: 'og:image:type',
          content: 'image/jpg',
        },
        { hid: 'og:image:height', property: 'og:image:height', content: '720' },
        { hid: 'og:image:width', property: 'og:image:width', content: '720' },
        { hid: 'og:image:alt', property: 'og:image:alt', content: '' },
        { hid: 'og:type', property: 'og:type', content: 'website' },
        //Twitter tags
        {
          hid: 'twitter:card',
          name: 'twitter:type',
          content: 'summary_large_image',
        },
        {
          hid: 'twitter:url',
          name: 'twitter:url',
          content: 'https://penthejourney.com/policies/',
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: 'Policies∙ Pen The Journey',
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: "Our store's rules and guidelines",
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content: 'https://penthejourney.com/ptjlogotransparent.png',
        },
        { hid: 'twitter:image:alt', name: 'twitter:image:alt', content: '' },
      ],
    }
  },
}
